import React from 'react'
import styled from 'styled-components'

const SectionWrapper = styled.section`
  width: 100%;
  height: auto;
  margin-top: 100px;
  @media screen and (max-width: 1023px) {
    margin-top: 80px;
  }
  @media screen and (max-width: 800px) {
    margin-top: 60px;
  }
`
const SectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 86%;
  max-width: var(--max-width);
  margin: 0 auto;
  @media screen and (max-width: 800px) {
    flex-direction: column;
    width: calc(100% - 50px);
    margin: 0 25px;
  }
`
const LeftColumn = styled.div`
  width: calc(50% - 50px);
  padding-right: 50px;
  text-align: right;
  h2 {
    margin-bottom: 20px;
  }
  @media screen and (max-width: 1023px) {
    width: calc(50% - 60px);
    padding-right: 40px;
  }
  @media screen and (max-width: 800px) {
    width: 100%;
    padding: 0;
    text-align: left;
  }
`
const RightColumn = styled.div`
  width: calc(50% + 50px);
  padding-left: 50px;
  border-left: 1px solid var(--black-light);
  .paragraph-1,
  .paragraph-2,
  .paragraph-3 {
    color: var(--text);
    font-size: var(--fz-md);
  }
  .paragraph-1,
  .paragraph-2 {
    margin-bottom: 15px;
  }
  @media screen and (max-width: 1023px) {
    width: calc(50% + 40px);
    border: none;
    padding: 0;
    text-align: left;
  }
  @media screen and (max-width: 800px) {
    width: 100%;
  }
`

const HomeWhy = () => {
  return (
    <SectionWrapper>
      <SectionContainer>
        <LeftColumn>
          <h2>What sets me apart</h2>
        </LeftColumn>
        <RightColumn>
          <p className="paragraph-1">What sets me apart as a Shopify developer is my ability to provide clients with a comprehensive and tailored solution that meets their individual needs. I have extensive experience developing and designing websites, applications, and other digital projects. My background in web development and design allows me to create unique and customized solutions that will help businesses stand out and achieve their goals.</p>
          <p className="paragraph-2">I approach each project with a creative and open mindset, allowing me to think outside the box and come up with innovative solutions. I believe in open communication and strive to provide my clients with the highest quality of service and support. I'm always up to date with the latest technologies and trends, so that I can create the best possible solution for my clients.</p>
          <p className="paragraph-3">Additionally, I'm committed to staying on top of the changing eCommerce landscape, so that I can ensure my clients are always at the forefront of the industry.</p>
        </RightColumn>
      </SectionContainer>
    </SectionWrapper>
  )
}

export default HomeWhy
